import { getEmptyValue } from './getEmptyValue';
import { getFilterValue } from './getFilterValue';
import { IGetQueryStateValuesProps } from './types';

export const getQueryStateValue = (
  queryStateProps: IGetQueryStateValuesProps,
): string =>
  getFilterValue<string>(queryStateProps) ??
  getEmptyValue(queryStateProps.accessorKey);
